import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./reducerManager";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
        ],
        ignoredActionPaths: [
          "meta.arg",
          "payload.data",
          "payload.headers",
        ],
        ignoredPaths: [],
        warnAfter: 128,
      },
    }),
});
export default store;
